import React from "react";
import { SizeGuide, needsSizeGuide } from "@/components/product/SizeGuide";

export function VariantPicker({ product, value, onChange, className = "", testId }) {
  if (!(product.variants?.length > 1)) return null;
  return (
    <div className={className} data-testid={testId}>
      <div className="mb-2 flex items-center justify-between">
        <p className="text-luxe text-[10px] text-ink">{product.options?.name || "Options"}</p>
        {needsSizeGuide(product) && <SizeGuide category={product.category} />}
      </div>
      <div className="flex flex-wrap gap-2">
        {product.variants.map((v) => (
          <button
            key={v.id}
            type="button"
            onClick={() => onChange(v)}
            aria-pressed={value?.id === v.id}
            data-testid="variant-option"
            className={`min-w-[54px] border px-4 py-2.5 text-xs transition-colors ${
              value?.id === v.id ? "border-ink bg-ink text-ivory" : "border-border text-ink hover:border-gold"
            }`}
          >
            {v.title}
          </button>
        ))}
      </div>
    </div>
  );
}
